// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { useEffect, useState } from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { findIana, findIanaAliases } from 'windows-iana';
import { Event } from 'microsoft-graph';
import { AuthenticatedTemplate } from '@azure/msal-react';
import { add, format, getDay, parseISO } from 'date-fns';
import { endOfWeek, startOfWeek } from 'date-fns/esm';

import { getUserWeekCalendar } from '../../GraphService';
import { useAppContext } from '../../AppContext';
import CalendarDayRow from './CalendarDayRow';
import './Calendar.css';
import LayoutTop from '../Layout/LayoutTop';
import LayoutBottom from '../Layout/LayoutBottom';

export default function Calendar(props: any) {
  const app = useAppContext();

  const [events, setEvents] = useState<Event[]>();

  useEffect(() => {
    const loadEvents = async() => {
      if (app.user && !events) {
        try {
          const ianaTimeZones = findIanaAliases("Asia/Riyadh");
          console.log(ianaTimeZones);
          const events = await getUserWeekCalendar(app.authProvider!, ianaTimeZones[0].valueOf());
          setEvents(events);
        } catch (err: any) {
          app.displayError!(err.message);
        }
      }
    };

    loadEvents();
  });

  // <ReturnSnippet>
  const weekStart = startOfWeek(new Date());
  const weekEnd = endOfWeek(weekStart);

  return (
    <AuthenticatedTemplate>
          <>
       <LayoutTop/>
    <div className="wrapper3 wrapper4">
            <div className="container-fluid">
                <h4 className="shape-round mb-lg-5 pb-5">تقويم الاسبوع : {format(weekStart, 'd')} - {format(weekEnd, 'MMMM d')}</h4>
              
                
    
     
      <div className="calendar-week">
        <div className="table-responsive">
          { events && <Table size="sm">
            <thead>
              <tr>
                <th>اليوم</th>
                <th>الوقت</th>
                <th>الحدث</th>
              </tr>
            </thead>
            <tbody>
              <CalendarDayRow
                date={weekStart}
                timeFormat={app.user?.timeFormat!}
                events={events!.filter(event => getDay(parseISO(event.start?.dateTime!)) === 0) } />
              <CalendarDayRow
                date={add(weekStart, { days: 1 })}
                timeFormat={app.user?.timeFormat!}
                events={events!.filter(event => getDay(parseISO(event.start?.dateTime!)) === 1) } />
              <CalendarDayRow
                date={add(weekStart, { days: 2 })}
                timeFormat={app.user?.timeFormat!}
                events={events!.filter(event => getDay(parseISO(event.start?.dateTime!)) === 2) } />
              <CalendarDayRow
                date={add(weekStart, { days: 3 })}
                timeFormat={app.user?.timeFormat!}
                events={events!.filter(event => getDay(parseISO(event.start?.dateTime!)) === 3) } />
              <CalendarDayRow
                date={add(weekStart, { days: 4 })}
                timeFormat={app.user?.timeFormat!}
                events={events!.filter(event => getDay(parseISO(event.start?.dateTime!)) === 4) } />
              <CalendarDayRow
                date={add(weekStart, { days: 5 })}
                timeFormat={app.user?.timeFormat!}
                events={events!.filter(event => getDay(parseISO(event.start?.dateTime!)) === 5) } />
              <CalendarDayRow
                date={add(weekStart, { days: 6 })}
                timeFormat={app.user?.timeFormat!}
                events={events!.filter(event => getDay(parseISO(event.start?.dateTime!)) === 6) } />
            </tbody>
          </Table> }
        </div>
      </div>
      </div>
        </div>
        <LayoutBottom/>

    </>
    </AuthenticatedTemplate>
  );
  // </ReturnSnippet>
}
